import { render, staticRenderFns } from "./PayrollViewEdit.vue?vue&type=template&id=acc2a99e&"
import script from "./PayrollViewEdit.vue?vue&type=script&lang=js&"
export * from "./PayrollViewEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports